import { DEFAULT_LANGUAGE } from '@/utils/constants/commons'

import en from '@/config/locales/en'
import ja from '@/config/locales/ja'

export default defineI18nConfig(() => ({
  locale: DEFAULT_LANGUAGE,
  fallbackLocale: DEFAULT_LANGUAGE,
  messages: {
    en,
    ja
  }
}))
